import { BlockAction as DbBlockAction } from "@prisma/client";
import { blockActionTypeDbToJson } from "server/models/util/blockAction/blockActionTypeDbToJson";
import { Form } from "../types";
import {
  FormBlockAction,
  FormBlockSchema,
  NavigateActionSchema,
  NotificationActionSchema,
  OpenExternalUrlActionSchema,
} from "../schema";
import { map as mapFieldBlock } from "../../Field/lib/map";

export const map: Form["map"] = (block) => ({
  type: "form-block",
  children: (block.children ?? []).map(mapFieldBlock),
  config: {
    ...FormBlockSchema.shape.config
      .omit({ triggers: true })
      .parse(block.config),
    id: block.id,
    triggers: (block.actions ?? []).map(mapFormAction),
  },
});

export function mapFormAction(action: DbBlockAction): FormBlockAction {
  const actionType = blockActionTypeDbToJson(action.type);
  switch (actionType) {
    case "notification":
      return {
        type: actionType,
        config: {
          ...NotificationActionSchema.shape.config.parse(action.config),
          id: action.id,
        },
      };
    case "navigate":
      return {
        type: actionType,
        config: {
          ...NavigateActionSchema.shape.config.parse(action.config),
          id: action.id,
        },
      };
    case "openExternalUrl":
      return {
        type: actionType,
        config: {
          ...OpenExternalUrlActionSchema.shape.config.parse(action.config),
          id: action.id,
        },
      };
    case "chatbot-button":
      throw new Error(`Not a form action: ${actionType}`);
    default:
      const _exhaustiveCheck: never = actionType;
      return _exhaustiveCheck;
  }
}
